import axios from 'axios';

// Function to handle logout
const handleLogout = () => {
    sessionStorage.clear(); // Clear all session storage
    window.location.href = '/login'; // Redirect to login page
};

// Add response interceptor
axios.interceptors.response.use(
    (response) => {
        // Check if response contains token expiry message
        if (response.data?.message === "Invalid or expired token") {
            handleLogout();
            return Promise.reject(new Error('Token expired'));
        }
        return response;
    },
    (error) => {
        // Handle error responses
        if (error.response) {
            const { status, data } = error.response;
            
            // Check for token expiry (status 401 or specific message)
            if (status === 401 || 
                data?.message === "Invalid or expired token" ||
                data?.message === "Token expired" ||
                data?.message === "Authentication failed") {
                handleLogout();
                return Promise.reject(new Error('Token expired'));
            }
        }
        return Promise.reject(error);
    }
);

export default axios;